import React from 'react';
import { Autoplay, Keyboard, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.css';
import { useNavigate } from "react-router-dom";

import comm from '../../assets/img/together.jpg';
import focus from '../../assets/img/journey.jpg';
import invention from '../../assets/img/invention.jpg';

import Nav from '../NavNew/Nav';
import classes from './Carousel.module.css';

const Carousel = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.header}>
      <Nav />
      <Swiper
        className={classes.swiper_container}
        loop={true}
        autoplay={{ delay: 4500, pauseOnMouseEnter: false }}
        slidesPerView={1}
        speed={1000}
        pagination={{ clickable: true }}
        navigation={true}
        keyboard={true}
        scrollbar={{ draggable: false }}
        modules={[Pagination, Autoplay, Navigation, Keyboard]}
        style={{ height: "100vh", width: "100vw", top: "5.5rem" }}
        cssMode={true}
        spaceBetween={90}
        mousewheel={true}
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <img
            className={classes.image}
            src={comm}
            alt="Team collaboration at work"
          />
          <div className={classes.carousel_text}>
            <h2>Transforming Ideas into Reality</h2>
            <p>
              Welcome to IQApex Labs, your one-stop solution to all your IT service and
              software development needs...
            </p>
            <div className={classes.buttons}>
              <button className={classes.btn_learn} onClick={() => navigate("/aboutUs")}>
                Learn More
              </button>
              <button className={classes.btn_contact} onClick={() => navigate("/contact-us")}>
                ▶ Contact Us
              </button>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <img
            className={classes.image}
            src={focus}
            alt="Business focus journey"
          />
          <div className={classes.carousel_text}>
            <h2>Your Passion, Our Creation</h2>
            <p>
              We provide tailored Software Development and digital marketing solutions...
            </p>
            <div className={classes.buttons}>
              <button className={classes.btn_learn} onClick={() => navigate("/aboutUs")}>
                Learn More
              </button>
              <button className={classes.btn_contact} onClick={() => navigate("/contact-us")}>
                ▶ Contact Us
              </button>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <img
            className={classes.image}
            src={invention}
            alt="Innovation and invention concept"
          />
          <div className={classes.carousel_text}>
            <h2>Research-based Product Development</h2>
            <p>
              We provide research-based product development expertise...
            </p>
            <div className={classes.buttons}>
              <button className={classes.btn_learn} onClick={() => navigate("/aboutUs")}>
                Learn More
              </button>
              <button className={classes.btn_contact} onClick={() => navigate("/contact-us")}>
                ▶ Contact Us
              </button>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Carousel;
